export function isoNow(date = new Date()) {
  return date.toISOString();
}

export function localDateKey(date = new Date(), timeZone?: string) {
  const parts = new Intl.DateTimeFormat("en", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);

  const year = parts.find((part) => part.type === "year")?.value;
  const month = parts.find((part) => part.type === "month")?.value;
  const day = parts.find((part) => part.type === "day")?.value;

  return `${year}-${month}-${day}`;
}

export function userTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Kolkata";
}

export function dateKeyToUtcMs(dateKey: string) {
  const [year, month, day] = dateKey.split("-").map(Number);
  if (!year || !month || !day) return null;
  return Date.UTC(year, month - 1, day);
}

export function daysSince(dateKey: string | null | undefined, timeZone?: string, now = new Date()) {
  if (!dateKey) return null;

  const then = dateKeyToUtcMs(dateKey);
  const today = dateKeyToUtcMs(localDateKey(now, timeZone));
  if (then === null || today === null) return null;

  return Math.max(0, Math.floor((today - then) / 86_400_000));
}

export function formatLongDate(date = new Date(), timeZone?: string) {
  return new Intl.DateTimeFormat("en", {
    timeZone,
    weekday: "long",
    month: "long",
    day: "numeric",
  }).format(date);
}

export function greeting(date = new Date(), timeZone?: string) {
  const hour = Number(
    new Intl.DateTimeFormat("en", {
      timeZone,
      hour: "2-digit",
      hour12: false,
    }).format(date),
  );

  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
}
